import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, filter, map, merge, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { BoschUiIconNames } from '../bosch-ui-icon/bosch-ui-icon.constants';
import { BoschUiButtonTypeEnum } from '../bosch-ui-button/bosch-ui-button.model';
import { BoschUiIconComponent } from '../bosch-ui-icon/bosch-ui-icon.component';
import { BoschUiButtonComponent } from '../bosch-ui-button/bosch-ui-button.component';

@Component({
  selector: 'bosch-ui-accordion',
  standalone: true,
  imports: [CommonModule, BoschUiIconComponent, BoschUiButtonComponent],
  templateUrl: './bosch-ui-accordion.component.html',
  styleUrls: ['./bosch-ui-accordion.component.scss'],
  exportAs: 'accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiAccordionComponent {
  @Input() set expanded(isExpanded: boolean | null) {
    this._expandFromOutside$.next(isExpanded);
  }
  @Input() title: string | null = null;
  @Input() small = false;
  @Input() hasButton = true;

  readonly iconNames = BoschUiIconNames;
  readonly isExpanded$!: Observable<boolean>;
  readonly icon$!: Observable<BoschUiIconNames>;
  readonly buttonType = BoschUiButtonTypeEnum;
  private _expandFromOutside$ = new BehaviorSubject<boolean | null>(null);
  private _isExpanded$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.isExpanded$ = merge(this._isExpanded$, this._expandFromOutside$).pipe(
      filter((isExpanded: boolean | null): isExpanded is boolean => isExpanded !== null),
    );
    this.icon$ = this.isExpanded$.pipe(
      map((isOpen: boolean) => (isOpen ? BoschUiIconNames.Up : BoschUiIconNames.Down)),
    );
  }

  protected toggle(): void {
    const expandedFromOutside = this._expandFromOutside$.getValue();

    if (expandedFromOutside === null) {
      const isExpanded = !this._isExpanded$.getValue();
      this._isExpanded$.next(isExpanded);
    }
  }
}
